import type { SVGProps } from 'react';

const SvgArrowBackIosNew = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M17.77 3.77 16 2 6 12l10 10 1.77-1.77L9.54 12z" />
  </svg>
);
export default SvgArrowBackIosNew;
